import gql from "graphql-tag";

export const MY_TIMESHEET_GET_SUMMARIES_BY_CONTRACT = gql`
  query timesheetsSummariesByContract($contract: String!) {
    timesheetsSummariesByContract(contract: $contract) {
      weeklyCost
      weeklyDuration
      weeklyDurationBillable
      monthlyCost
      monthlyDuration
      monthlyDurationBillable
    }
  }
`;
